import { SBox } from '@avalara/skylab-sdk/react';
import type { ReactNode } from 'react';

import { LightGreyRoundedBox } from '../styled';

type Props = {
  children: Array<ReactNode> | ReactNode;
  className?: string;
  id?: string;
  isEmbedded?: boolean;
};

const OfferBox = ({ children, className, id, isEmbedded }: Props) =>
  isEmbedded ? (
    <SBox id={id} class={`secondary ${className ?? ''}`}>
      {children}
    </SBox>
  ) : (
    <LightGreyRoundedBox data-ref='buy.offerBox' id={id} className={className ?? ''}>
      {children}
    </LightGreyRoundedBox>
  );
export default OfferBox;
